import styled from 'styled-components';

export const Footer = styled.div`
  position: fixed;
  left: 0px;
  bottom: 0;
  width: 100%;

  padding: 24px 24px 0px 24px;
  background-color: #fff;
  border-top: 0.8px solid #000;

  @media (min-width: 1025px) {
    left: 70px;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px 50px;

  @media (min-width: 1025px) {
    justify-content: space-around;
  }

  .clear-selection {
    margin-bottom: 16px;
    color: #000;
    text-decoration: underline;
  }
`;

export const Row = styled.div``;

export const Title = styled.h1`
  display: flex;
  flex-direction: column;
  color: #8d929e;
  margin: 0;

  font-weight: 400;
  font-size: 13px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'apple color emoji', 'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
`;

export const Value = styled.h2<{ color?: string }>`
  color: ${({ color }) => color || '#000'};

  font-weight: 600;
  font-size: 22px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'apple color emoji', 'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
`;
